import React, { Component } from 'react';
import SummaryFlights from 'components/components/common/SummaryFlights';

class FlightDetailsContainer extends Component {
  render() {
    const { passengersData } = this.props;
    var passengersProps = {};
    if (passengersData) {
      for (var obj of passengersData) {
        var number = obj['number'];
        var key = obj['label'];
        if (key == 'seniors') {
          passengersProps['seniorsNumber'] = number;
        }
        if (key == 'teenagers') {
          passengersProps['teenagersNumber'] = number;
        }
        if (key == 'students') {
          passengersProps['studentsNumber'] = number;
        }
      }
    }

    var camelCaseProps = {
      adultsNumber: this.props.adults,
      childrenNumber: this.props.children,
      departureAddress: { phrase: this.props.address_phrase },
      returnAddress: { phrase: null },
      departureFlight: this.props.flight,
      returnFlight: null,
      differentReturnAddress: false,
      price: this.props.price,
      paymentToDriver: this.props.payment_to_driver,
      locale: this.props.locale,
      flightType: this.props.reservation_direction,
      departureInfo: this.props.timetableInfo,
      ...passengersProps
    }
    return (<SummaryFlights isDashboard {...camelCaseProps} />);
  }
}

export default FlightDetailsContainer;
